import Tabs from 'antd/lib/tabs'
// import Form from 'antd/lib/form'

import Layout from 'components/Layout'
import MainContentContainer from 'components/MainContentContainer'

import { IRESSLogo } from 'assets/images'

import {
  StyledContainer,
  StyledHeaderContainer,
  StyledLeftContainer,
  StyledRightContainer,
  StyledImg,
  StyledName,
  StyledDescription,
  StyledColumn,
  // StyledOptionContainer,
  // StyledHeading,
} from './QuickSearch.styles'
import ClientDetailsTab from './Tabs/ClientDetailsTab/ClientDetailsTab'
import PropertyAndLandingTab from './Tabs/PropertyAndLandingTab/PropertyAndLandingTab'
import FurtherInformationTab from './Tabs/FurtherInformationTab/FurtherInformationTab'
import useQuickSearchPage from 'hooks/clients/useQuickSearchPage'
import MedicalQuestionsTab from './Tabs/MedicalQuestionsTab/MedicalQuestionsTab'
// import MortgageTab from './Tabs/MortgageTab'
// import CustomFormItem from 'components/CustomFormItem'

const { TabPane } = Tabs

const QuickSearch = () => {
  const {
    handleTabChange,

    displayDetailForm,
    handleDetailedFormClose,
    medicalQuestionsTabItems,
    breadcrumbItems,
    handleBreadcrumbTabChange,
    handleItemClick,
    detailedFormName,
    // handleOptionChange,
    // sourcingOptions,
    activeTab,
    // selectedOption,
    tabs,
  } = useQuickSearchPage()

  return (
    <Layout>
      <MainContentContainer pageName="Search With IRESS">
        <StyledContainer>
          <StyledHeaderContainer>
            <StyledLeftContainer>
              <StyledImg src={IRESSLogo} />
            </StyledLeftContainer>
            <StyledRightContainer>
              <StyledColumn>
                <StyledName>Quick search</StyledName>
                <StyledDescription>Note: search process is performed via Iress</StyledDescription>
              </StyledColumn>
            </StyledRightContainer>
          </StyledHeaderContainer>

          {/*
          
          Note: The following code is commented out. this was intended to add mortgage sourcing options to the quick search page, but
          development was halted so this is not ready for production yet.
          
          <StyledOptionContainer>
            <StyledHeading>Select a Sourcing Option: Mortgage or Equity Release</StyledHeading>
            <Form
              layout="vertical"
              size="large"
              name="basic"
              initialValues={{ sourcingOption: selectedOption }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                rowGap: '12px',
                marginTop: '8px',
                width: '100%',
              }}
            >
              <CustomFormItem
                onChange={handleOptionChange}
                options={sourcingOptions}
                value={selectedOption}
                type="radio"
                rules={['isRequired']}
                name="sourcingOption"
              />
            </Form>
          </StyledOptionContainer>

          <Tabs style={{ width: '100%' }} activeKey={activeTab} type="card" onChange={handleTabChange}>
            {selectedOption === 'mortgageSourcing' ? (
              <TabPane tab={tabs.mortgage} key={tabs.mortgage}>
                <MortgageTab />
              </TabPane>
            ) : (
              <>
                <TabPane tab={tabs.clientDetails} key={tabs.clientDetails}>
                  <ClientDetailsTab />
                </TabPane>
                {!!tabs?.medicalQuestions && (
                  <TabPane tab={tabs.medicalQuestions} key={tabs.medicalQuestions}>
                    <MedicalQuestionsTab
                      displayDetailForm={displayDetailForm}
                      handleDetailedFormClose={handleDetailedFormClose}
                      items={medicalQuestionsTabItems}
                      breadcrumbItems={breadcrumbItems}
                      handleBreadcrumbTabChange={handleBreadcrumbTabChange}
                      handleItemClick={handleItemClick}
                      detailedFormName={detailedFormName}
                    />
                  </TabPane>
                )}
                <TabPane tab={tabs.propertyAndLanding} key={tabs.propertyAndLanding}>
                  <PropertyAndLandingTab />
                </TabPane>
                <TabPane tab={tabs.furtherInformation} key={tabs.furtherInformation}>
                  <FurtherInformationTab />
                </TabPane>
              </>
            )}
          </Tabs> */}
          <Tabs style={{ width: '100%' }} activeKey={activeTab} type="card" onChange={handleTabChange}>
            <TabPane tab={tabs.clientDetails} key={tabs.clientDetails}>
              <ClientDetailsTab />
            </TabPane>
            {!!tabs?.medicalQuestions && (
              <TabPane tab={tabs.medicalQuestions} key={tabs.medicalQuestions}>
                <MedicalQuestionsTab
                  displayDetailForm={displayDetailForm}
                  handleDetailedFormClose={handleDetailedFormClose}
                  items={medicalQuestionsTabItems}
                  breadcrumbItems={breadcrumbItems}
                  handleBreadcrumbTabChange={handleBreadcrumbTabChange}
                  handleItemClick={handleItemClick}
                  detailedFormName={detailedFormName}
                />
              </TabPane>
            )}
            <TabPane tab={tabs.propertyAndLanding} key={tabs.propertyAndLanding}>
              <PropertyAndLandingTab />
            </TabPane>
            <TabPane tab={tabs.furtherInformation} key={tabs.furtherInformation}>
              <FurtherInformationTab />
            </TabPane>
          </Tabs>
        </StyledContainer>
      </MainContentContainer>
    </Layout>
  )
}

export default QuickSearch
